import React from "react";
import ToggleChevron from "./ToggleChevron";

const Skeleton: React.FC = () => {
  return (
    <div data-testid="skelly">
      <div className="flex">
        <aside className="col-span-1 flex w-15 flex-col inset-y-0 p-6 bg-gray-50">
          <div className="bg-white flex flex-col min-h-0 rounded-lg border shadow">
            <header className="flex items-center h-16 flex-shrink-0 px-4 col-start-1 col-span-4 justify-center">
              <div className="col-end-7 col-span-1 text-orange-600">
                <ToggleChevron onClick={() => {}} />
              </div>
            </header>
            <nav
              role="tabpanel"
              className="flex-1 overflow-y-auto py-4 space-y-1"
            >
              {[...Array(5)].map((_, index) => (
                <span
                  key={index}
                  className="skeleton-text skeleton border-l-4 border-green-600"
                />
              ))}
              <UserProfile />
            </nav>
          </div>
        </aside>
        <main className="flex-1 col-span-3">
          <div className="p-6">
            <div className="max-w-8xl mx-auto">
              <div className="flex justify-between items-center pb-6">
                <span className="text-4xl leading-10 font-extrabold skeleton skeleton__grey skeleton-heading"></span>
              </div>
            </div>
            <div className="opacity-40">
              <div>
                <div className="flex text-gray-500 rounded-t-xl border shadow shadow-gray-300">
                  <div className="flex rounded-t-xl items-center p-3 text-xs leading-4 font-medium bg-gray-50 uppercase flex-1"></div>
                  <div className="flex rounded-t-xl items-center p-3 text-xs leading-4 font-medium bg-gray-50 uppercase flex-1"></div>
                </div>
                <div className="bg-white border-l border-r rounded-b-xl shadow shadow-gray-300">
                  <div>
                    <div className="flex border-b text-xs leading-4 font-normal py-4 hover:bg-gray-50"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const UserProfile: React.FC = () => (
  <div className="pt-60">
    <div className="p-2">
      <div className="flex">
        <span className="shadow-xl rounded-full border-1 w-10 row-span-3 skeleton skeleton-block" />
        <div className="flex flex-col justify-center items-left flex-grow px-2">
          <span className="flex justify-center items-center skeleton skeleton-small skeleton__grey" />
        </div>
      </div>
    </div>
  </div>
);

export default Skeleton;
